<template lang="pug">
.card.radius-card
  .card-header
    .columns.align-center
      .column #[.h5 Resumo dos últimos meses]
      .column.col-auto #[i.fas.fa-chart-line.fa-lg]
  .card-body
    highcharts(:options="options")
</template>

<script>
const mapSeriesOptions = {
  filiationSubscriptions: {
    name: 'Assinaturas',
    color: '#3b4351',
  },
  filiationPurchases: {
    name: 'Compras',
    color: '#e24328',
  },
  filiationAccess: {
    name: 'Acessos',
    color: '#DBA42A',
  },
}

export default {
  props: {
    value: { type: Object, default: () => ({ labels: [], series: {} }) },
  },
  computed: {
    labels() {
      return this.value.labels.map(dateJSON => {
        const options = { year: 'numeric', month: 'long', timeZone: 'UTC' }
        const date = new Date(dateJSON)
        return date.toLocaleDateString(navigator.language, options)
      })
    },
    series() {
      const keys = Object.keys(this.value.series)
      return keys.map(key => {
        const defaults = mapSeriesOptions[key] || {}
        return {
          ...defaults,
          data: this.value.series[key],
        }
      })
    },
    options() {
      return {
        title: { text: '' },
        chart: { height: 300 },
        xAxis: { categories: this.labels },
        yAxis: {
          title: { text: 'Quantidade' },
          plotLines: [
            {
              value: 0,
              width: 1,
              color: '#808080',
            },
          ],
        },
        series: this.series,
      }
    },
  },
}
</script>
